<template>
<section class="page-contact-us">
  <div class="qbk-header">
    <img src="../assets/images/logo-red.svg" alt="">
  </div>
  <div class="qbk-contact-us-content">
    <div class="qbk-wrap">
      <h1>Let’s get in touch</h1>
      <div class="row">
        <div class="col-12 col-md-4">
          <h3>Address</h3>
          <p>Medang, Pagedangan, Tangerang, Banten 15334</p>
        </div>
        <div class="col-12 col-md-4">
          <h3>Contact</h3>
          <p>
            <a target="_blank" href="mailto:info@qubikahotel.com">info@qubikahotel.com</a>
            <a target="_blank" href="mailto:reservation@qubikahotel.com">reservation@qubikahotel.com</a>
            <a target="_blank" href="tel:+622122970888">021 – 2297 0888</a>
            <a target="_blank" href="tel:+6282246457423">0822 4645 7423</a>
          </p>
        </div>
        <div class="col-12 col-md-4">
          <h3>Follow Us</h3>
          <p class="d-flex justify-content-start">
            <a target="_blank" href="https://www.instagram.com/qubikahotelserpong/" class="mr-1"> <img src="../assets/images/ig.svg" alt=""></a>
            <a target="_blank" href="https://www.facebook.com/qubikahotel"> <img src="../assets/images/fb.svg" alt=""></a>
          </p>
        </div>
        <div class="col-12 col-md-6">
          <input type="text" placeholder="Your Name*" v-model="form.data.title">
          <input type="text" placeholder="Email*" v-model="form.data.child.email.content">
          <input type="text" placeholder="Phone*" v-model="form.data.child.phone.content">
        </div>
        <div class="col-12 col-md-6">
          <textarea placeholder="Your Message" v-model="form.data.content"></textarea>
        </div>
        <div class="col-12 col-md-6">
          <p class="qbk-req">* Required</p>
        </div>
        <div class="col-12 col-md-6">
          <button type="button" @click="doSend()">Send</button>
        </div>
        <div class="col-12">
          <div class="qbk-maps">
            <div class="gmap_canvas"><iframe width="100%" height="500" id="gmap_canvas" src="https://maps.google.com/maps?q=Qubika&t=&z=15&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import axios from 'axios'
import {
  baseUrl
} from '../config'
export default {
  data() {
    return {
      form: {
        loading: false,
        data: {
          id: null,
          image: null,
          title: null,
          content: null,
          id_parent: null,
          type: 'CONTACT US MESSAGE ITEM',
          child: {
            email: {
              id: null,
              image: null,
              title: 'CONTACT US MESSAGE EMAIL ITEM',
              content: null,
              id_parent: null,
              type: 'CONTACT US MESSAGE EMAIL ITEM',
            },
            phone: {
              id: null,
              image: null,
              title: 'CONTACT US MESSAGE PHONE ITEM',
              content: null,
              id_parent: null,
              type: 'CONTACT US MESSAGE PHONE ITEM',
            }
          }
        },
        deleteId: null
      },
    }
  },
  methods: {
    doSend() {
      this.form.loading = true
      let formData = this.form.data
      if (!formData.title || !formData.content || !formData.child.email.content || !formData.child.phone.content) {
        this.form.loading = false
        this.notif('Warning', 'Please fill required form', 'warning')
      } else {
        let url = baseUrl + '/api/post/create'
        if (this.form.data.id)
          url = baseUrl + '/api/post/update'
        axios.post(url, this.form.data)
          .then(res => {
            if (res.data.status) {
              this.notif('Success', 'Thank you for contact us', 'success')
              this.clearForm()
            } else {
              this.notif('Failed', 'Something went wrong please try again', 'danger')
            }
            this.form.loading = false
          })
          .catch(() => {
            this.form.loading = false
            this.notif('Failed', 'Save:Internal server error', 'danger')
          });
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    clearForm() {
      this.form = {
        loading: false,
        data: {
          id: null,
          image: null,
          title: null,
          content: null,
          id_parent: null,
          type: 'CONTACT US MESSAGE ITEM',
          child: {
            email: {
              id: null,
              image: null,
              title: 'CONTACT US MESSAGE EMAIL ITEM',
              content: null,
              id_parent: null,
              type: 'CONTACT US MESSAGE EMAIL ITEM',
            },
            phone: {
              id: null,
              image: null,
              title: 'CONTACT US MESSAGE PHONE ITEM',
              content: null,
              id_parent: null,
              type: 'CONTACT US MESSAGE PHONE ITEM',
            }
          }
        },
        deleteId: null
      }
    },
    notif(title, msg, type) {
      this.$bvToast.toast(msg, {
        title: title,
        autoHideDelay: 5000,
        variant: type,
        solid: true,
        toaster: 'b-toaster-bottom-left'
      })
    },
  }
}
</script>
